import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (typeof $ === "undefined" || !$.fn.select2) return

    if ($(this.element).hasClass("select2-hidden-accessible")) {
      $(this.element).select2("destroy")
    }

    const withSearch = this.element.dataset.select2Search !== "false"

    $(this.element).select2({
      minimumResultsForSearch: withSearch ? 0 : Infinity,
      dropdownCssClass: "custom-search-dropdown",
      width: "100%"
    })

    const container = $(this.element).next(".select2-container")
    const selection = container.find(".select2-selection")

    selection.addClass("form-control d-flex align-items-center")
    selection.css({
      height: 42,
      border: "1px solid #E4E6EF",
      borderRadius: "0.5rem"
    })

    container.find(".select2-selection__rendered").css({
      lineHeight: "42px",
      paddingLeft: "8px"
    })

    container.find(".select2-selection__arrow").hide()
  }

  disconnect() {
    if ($(this.element).hasClass("select2-hidden-accessible")) {
      $(this.element).select2("destroy")
    }
  }
}